import * as angular from 'angular';
import Color from 'color';
import './blipchat2Content.scss';
import sampleMessages from './sampleMessages.json';
import { ChannelBaseController } from '../ChannelBaseController';
import { ChannelsNames } from '../Channels';
import { ChannelsFeatures } from '../ChannelsFeatures';
import '!ng-cache-loader!./BlipChatWidgetView.html';
import '!ng-cache-loader!./blipchat2Tabs/BlipChat2ConfigurationsTab.html';
import '!ng-cache-loader!./blipchat2Tabs/BlipChat2SetupTab.html';
import '!ng-cache-loader!./blipchat2Tabs/BlipChat2OverviewTab.html';
const defaultDomains = [
    'localhost',
    'blip.ai',
    'preview.blip.ai',
    'portal.blip.ai',
    'hmg-preview.blip.ai',
    'hmg-portal.blip.ai',
];
const cultures = [
    'pt',
    'en',
    'es',
];
export class BlipChat2Controller extends ChannelBaseController {
    static $inject = ['application', 'ApplicationService2', 'LoadingService', 'PermissionsService', 'MessagingHubService', 'ChannelsSegmentService', 'ngToast', 'clipboard', 'BLIPCHATWIDGETURI', 'BLIPCHATEXAMPLEURI', 'MEDIA_BUCKET_URI', 'MEDIA_PROFILE_FOR_AVATARS', '$translate', '$scope', '$rootScope', 'TenantService', 'BLIPCHATURI', 'BLIPCHATURITENANT', 'SharedToastsService', '$window', '$timeout', 'ChannelsService'];
    constructor(application, ApplicationService2, LoadingService, PermissionsService, MessagingHubService, ChannelsSegmentService, ngToast, clipboard, BLIPCHATWIDGETURI, BLIPCHATEXAMPLEURI, MEDIA_BUCKET_URI, MEDIA_PROFILE_FOR_AVATARS, $translate, $scope, $rootScope, TenantService, BLIPCHATURI, BLIPCHATURITENANT, SharedToastsService, $window, $timeout, ChannelsService) {
        'ngInject';
        super(ChannelsNames.Blipchat, ChannelsService, ApplicationService2, application);
        this.ApplicationService2 = ApplicationService2;
        this.LoadingService = LoadingService;
        this.PermissionsService = PermissionsService;
        this.MessagingHubService = MessagingHubService;
        this.ChannelsSegmentService = ChannelsSegmentService;
        this.ngToast = ngToast;
        this.clipboard = clipboard;
        this.BLIPCHATWIDGETURI = BLIPCHATWIDGETURI;
        this.BLIPCHATEXAMPLEURI = BLIPCHATEXAMPLEURI;
        this.MEDIA_BUCKET_URI = MEDIA_BUCKET_URI;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.TenantService = TenantService;
        this.BLIPCHATURI = BLIPCHATURI;
        this.BLIPCHATURITENANT = BLIPCHATURITENANT;
        this.SharedToastsService = SharedToastsService;
        this.$window = $window;
        this.$timeout = $timeout;
        this.ChannelsService = ChannelsService;
        this.receiveFiles = false;
        this.authenticatedMedias = false;
        this.recordAudio = false;
        this.openImageInFrame = false;
        this.showAuthenticatedMediasToggle = false;
        this.showRecordAudioToggle = false;
        this.showOpenImageInFrameToggle = false;
        this.showCultureBanner = false;
        this.transformDomain = async (event) => {
            if (this.domains?.join(',') !== event.detail.data?.join(',')) {
                this.domains = event.detail.data;
                this.domains = this.domains.map(value => {
                    if (value.indexOf('://') > -1) {
                        return value.split('/')[2];
                    }
                    else {
                        return value.split('/')[0];
                    }
                });
            }
        };
        this.onDisplayNameChange = (event) => {
            this.displayName = event.detail.value;
        };
        this.onReceiveFilesChange = (event) => {
            this.$timeout(() => {
                this.receiveFiles = event.detail.checked;
            });
        };
        this.onBlockExternalFilesChange = (event) => {
            this.$timeout(() => {
                this.blockExternalFiles = event.detail.checked;
            });
        };
        this.onAuthenticatedMediasChange = (event) => {
            this.$timeout(() => {
                this.authenticatedMedias = event.detail.checked;
            });
        };
        this.onRecordAudioChange = (event) => {
            this.$timeout(() => {
                if (event.detail.checked === this.recordAudio) {
                    return;
                }
                this.recordAudio = event.detail.checked;
                this.trackConnectionBlipchatConfigurationRecordAudioChanges(this.recordAudio);
            });
        };
        this.onOpenImageInFrameChange = (event) => {
            this.$timeout(() => {
                if (event.detail.checked === this.openImageInFrame) {
                    return;
                }
                this.openImageInFrame = event.detail.checked;
                this.trackConnectionBlipchatConfigurationOpenImageInFrameChanges(this.recordAudio);
            });
        };
        this.validateCulture = async () => {
            const applicationAccount = await this.getAccount();
            const applicationCulture = applicationAccount && applicationAccount.culture && applicationAccount.culture.length > 2
                ? applicationAccount.culture.slice(0, 2)
                : '';
            if (applicationCulture && !cultures.includes(applicationCulture)) {
                this.showCultureBanner = true;
            }
        };
        this._application = application;
        this.isActive = this.getIsActive();
        this.domains = this.getDomains();
        this.receiveFiles = false;
        this.blockExternalFiles = false;
        this.authenticatedMedias = false;
        this.recordAudio = false;
        this.srcUrl = this.BLIPCHATWIDGETURI;
        this.exampleUri = this.BLIPCHATEXAMPLEURI;
        this.mediaBucketUri = this.MEDIA_BUCKET_URI;
        this.sampleMessages = angular.copy(sampleMessages);
        this.iconUrl = undefined;
        this.dynamicScript = '';
        this.defaultComponentsColor = '#0096fa'; //$color-brand
        this.defaultChatColor = '#f5f5f5'; //$color-surface-2
        this.blipChatUri = this.TenantService.addTenantPrefixToUrl(this.BLIPCHATURITENANT, this.application?.tenantId, this.BLIPCHATURI);
        this.init();
    }
    async init() {
        this.ChannelsSegmentService.setApplication(this.application);
        await this.checkFeatures();
        this.hasPermissions = await this.PermissionsService.hasPermissions('write');
        this.$scope.$watch('$ctrl.componentColor', (newValue, oldValue) => {
            if (newValue === oldValue) {
                return;
            }
            this.setComponentsColor(newValue);
        });
        this.$scope.$watch('$ctrl.chatColor', (newValue, oldValue) => {
            if (newValue === oldValue) {
                return;
            }
            this.setBackgroundColor(newValue);
        });
        await this.fetchBotConfig();
        this.sampleMessages.forEach(x => {
            x.photo = x.photo ? this.botAccount.photoUri : undefined;
        });
        this.generateScript();
        this.closeColorPickersListener();
        this.botAccountExtrasCopy = angular.copy(this.botAccount.extras);
        await this.validateCulture();
    }
    closeColorPickersListener() {
        document.addEventListener('click', (event) => {
            const path = [];
            let node = event.target;
            let count = 0;
            while (node && node.localName != 'body' && count < 4) {
                path.push(node);
                node = node.parentNode;
                count++;
            }
            const el = path.find((e) => e.classList.contains('date-picker-wrapper'));
            if (el) {
                return;
            }
            this.$rootScope.$broadcast('toggleColorPicker', undefined);
        });
    }
    async fetchBotConfig() {
        this.botAccount = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `lime://msging.net/accounts/${this._application.shortName}`,
        });
        this.domains = this.getDomains();
        this.displayName =
            this.botAccount.extras['blipchat-display-name'] ||
                this.botAccount.fullName;
        this.initReceiveFiles();
        this.initBlockExternalFiles();
        this.initAuthenticatedMedias();
        this.initRecordAudio();
        this.initOpenImageInFrame();
        this.componentColor =
            this.botAccount.extras['blipchat-components-color'] ||
                this.defaultComponentsColor;
        this.chatColor =
            this.botAccount.extras['blipchat-chat-color'] ||
                this.defaultChatColor;
        if (this.botAccount.extras['blipchat-icon']) {
            this.iconUrl = {
                file: this.botAccount.extras['blipchat-icon'],
                name: this.botAccount.extras['blipchat-icon-name'],
            };
        }
        const botKey = this.botAccount.extras['blipchat-app-key'] || undefined;
        this.blipChatKey = btoa(`${this._application.shortName}:${botKey}`);
    }
    resetPalette() {
        this.componentColor = this.defaultComponentsColor;
        this.chatColor = this.defaultChatColor;
    }
    setComponentsColor(color) {
        const components = document.querySelectorAll('.component-color');
        const cards = document.querySelectorAll('.bubble.right');
        const cardsText = document.querySelectorAll('.bubble.right div');
        const quickReply = document.querySelectorAll('.select .options li');
        const nextButton = document.querySelectorAll('.next');
        const mediumLightenColor = Color(color).mix(Color('white'), 0.86).string();
        const strongLightenColor = Color(color).mix(Color('white'), 0.96).string();
        components.forEach((element) => {
            element.style.backgroundColor = color;
        });
        cards.forEach((element) => {
            element.style.backgroundColor = color;
            element.style.borderColor = mediumLightenColor;
        });
        cardsText.forEach((element) => {
            element.style.color = strongLightenColor;
        });
        quickReply.forEach((element) => {
            element.style.backgroundColor = color;
            element.style.color = strongLightenColor;
            element.style.border = color;
        });
        nextButton.forEach((element) => {
            element.style.color = color;
        });
    }
    setBackgroundColor(color) {
        const background = document.querySelector('.blip-chat2-widget');
        if (background) {
            background.style.backgroundColor = color;
        }
    }
    getIsActive() {
        return true;
    }
    getDomains() {
        return this.botAccount &&
            this.botAccount.extras &&
            this.botAccount.extras['blipchat-domains']
            ? this.botAccount.extras['blipchat-domains']
                .split(',')
                .filter(d => !defaultDomains.find(domain => domain == d))
                .reduce((x, y) => x.concat(y), [])
            : [];
    }
    codeToCopy() {
        this.$translate('blipchat2.copiedToClip').then((text) => {
            const textValue = document.getElementById('sdk-code').value;
            this.clipboard.copyText(textValue);
            this.ngToast.success(text);
        });
    }
    async save() {
        this.LoadingService.startLoading();
        const accountExtrasCopy = angular.copy(this.botAccount.extras);
        try {
            let auxDomains;
            if (this.domains && this.domains.length > 0) {
                auxDomains = this.domains;
                auxDomains = [...new Set(auxDomains)];
            }
            this.botAccount.extras['blipchat-domains'] = auxDomains
                ? auxDomains.reduce((x, y) => x.concat(y), []).join(',')
                : '';
            this.botAccount.extras['blipchat-icon'] = this.iconUrl ? this.iconUrl.file : undefined;
            this.botAccount.extras['blipchat-icon-name'] = this.iconUrl ? this.iconUrl.name : undefined;
            this.botAccount.extras['blipchat-display-name'] = this.displayName;
            this.botAccount.extras['blipchat-authenticated-medias'] = this.authenticatedMedias && this.receiveFiles ? 'True' : 'False';
            this.botAccount.extras['blipchat-record-audio'] = this.recordAudio && this.receiveFiles ? 'True' : 'False';
            this.botAccount.extras['blipchat-receive-files'] = this.receiveFiles ? 'True' : 'False';
            this.botAccount.extras['blipchat-block-external-files'] = this.blockExternalFiles && this.receiveFiles ? 'True' : 'False';
            this.botAccount.extras['blipchat-components-color'] = this.componentColor;
            this.botAccount.extras['blipchat-chat-color'] = this.chatColor;
            this.botAccount.extras['blipchat-open-image-in-frame'] = this.openImageInFrame ? 'True' : 'False';
            await this.MessagingHubService.sendCommand({
                method: 'set',
                type: 'application/vnd.lime.account+json',
                uri: '/account',
                resource: this.botAccount,
            });
            this.generateScript();
            this.afterUpdateBotAccountExtras();
            const successMsg8 = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMsg8);
        }
        catch (e) {
            this.botAccount.extras = accountExtrasCopy;
            const errorMsg8 = await this.$translate('utils.errorMsg.8');
            this.ngToast.danger(errorMsg8);
            throw e;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    resetIcon() {
        this.iconUrl = undefined;
    }
    async fileUploaded(file) {
        try {
            if (!file) {
                throw 'error';
            }
            this.LoadingService.startLoading();
            const mediaUri = await this.ApplicationService2.uploadFile(file, { profile: this.MEDIA_PROFILE_FOR_AVATARS });
            const fileUploadedMsg = await this.$translate('blipchat2.configs.iconTip');
            const name = file.name;
            this.iconUrl = { file: mediaUri, name };
            this.ngToast.success(fileUploadedMsg);
        }
        catch (err) {
            console.error(err);
            this.SharedToastsService.showUploadErrorToast(err.status);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async getAccount() {
        return await this.ApplicationService2.getAccount();
    }
    generateScript() {
        const floatBtnConfig = { color: '', icon: '' };
        if (this.componentColor) {
            floatBtnConfig.color = this.componentColor;
        }
        if (this.iconUrl) {
            floatBtnConfig.icon = this.iconUrl.file;
        }
        this.dynamicScript = `.withButton(${JSON.stringify(floatBtnConfig)})`;
    }
    async checkFeatures() {
        const isAuthenticatedMediaConfigurationEnabled = await ChannelsFeatures.isAuthenticatedMediaConfigurationEnabled();
        const isRecordAudioEnabled = await ChannelsFeatures.isAudioRecordEnabled();
        const isOpenImageInFrameEnabled = await ChannelsFeatures.isOpenImageInFrameEnabled();
        this.$timeout(() => {
            this.showAuthenticatedMediasToggle = isAuthenticatedMediaConfigurationEnabled;
            this.showRecordAudioToggle = isRecordAudioEnabled;
            this.showOpenImageInFrameToggle = isOpenImageInFrameEnabled;
        });
    }
    afterUpdateBotAccountExtras() {
        const addedFields = this.checkAddedFields(this.botAccount.extras, this.botAccountExtrasCopy);
        const changedFileds = this.checkChangedFields(this.botAccount.extras, this.botAccountExtrasCopy, addedFields);
        const addedExtrasFiltered = this.getExtrasFiltered(addedFields);
        const changedExtrasFiltered = this.getExtrasFiltered(changedFileds);
        if (addedFields.length > 0) {
            this.trackConnectionBlipchatConfigurationAddsSaved(addedFields, addedExtrasFiltered);
        }
        if (changedFileds.length > 0) {
            this.trackConnectionBlipchatConfigurationChangesSaved(changedFileds, changedExtrasFiltered);
        }
        this.botAccountExtrasCopy = angular.copy(this.botAccount.extras);
    }
    getExtrasFiltered(elementsChanged) {
        const extras = Object.entries(this.botAccount.extras || {});
        return extras.filter(([key]) => {
            return elementsChanged.includes(key);
        });
    }
    // Segment
    trackConnectionBlipchatConfigurationAddsSaved(addedFields, addedExtras) {
        this.ChannelsSegmentService
            .trackConnectionBlipchatConfigurationAddsSaved({
            AddedFileds: addedFields,
            AddedExtras: addedExtras,
        });
    }
    trackConnectionBlipchatConfigurationChangesSaved(changedFields, changeExtras) {
        this.ChannelsSegmentService
            .trackConnectionBlipchatConfigurationChangesSaved({
            ChangedFields: changedFields,
            ChangesExtras: changeExtras,
        });
    }
    trackConnectionBlipchatConfigurationRecordAudioChanges(isChecked) {
        this.ChannelsSegmentService
            .trackConnectionBlipchatConfigurationRecordAudioChanges({
            isChecked: isChecked,
        });
    }
    trackConnectionBlipchatConfigurationOpenImageInFrameChanges(isChecked) {
        this.ChannelsSegmentService
            .trackConnectionBlipchatConfigurationOpenImageInFrameChanges({
            isChecked: isChecked,
        });
    }
    async openDocumentation() {
        const documentationLink = await this.$translate('blipchat2.docs.externalLink');
        this.$window.open(documentationLink, '_blank', 'noopener noreferrer');
    }
    initReceiveFiles() {
        this.$timeout(() => {
            this.receiveFiles = this.botAccount.extras['blipchat-receive-files'] === 'True';
            const receiveFilesElements = document.getElementsByName('receiveFiles');
            if (receiveFilesElements && receiveFilesElements.length > 0) {
                const receiveFileElement = receiveFilesElements[0];
                receiveFileElement.checked = this.receiveFiles;
            }
        });
    }
    initBlockExternalFiles() {
        this.$timeout(() => {
            this.blockExternalFiles = !Object.keys(this.botAccount.extras).includes('blipchat-block-external-files') || this.botAccount.extras['blipchat-block-external-files'] === 'True';
            const blockExternalFilesElements = document.getElementsByName('blockExternalFiles');
            if (blockExternalFilesElements && blockExternalFilesElements.length > 0) {
                const blockExternalFileElement = blockExternalFilesElements[0];
                blockExternalFileElement.checked = this.blockExternalFiles;
            }
        });
    }
    initAuthenticatedMedias() {
        this.$timeout(() => {
            this.authenticatedMedias = this.showAuthenticatedMediasToggle && this.botAccount.extras['blipchat-authenticated-medias'] === 'True';
            const authenticatedMediasElements = document.getElementsByName('authenticatedMedias');
            if (authenticatedMediasElements && authenticatedMediasElements.length > 0) {
                const authenticatedMediasElement = authenticatedMediasElements[0];
                authenticatedMediasElement.checked = this.authenticatedMedias;
            }
        });
    }
    initRecordAudio() {
        this.$timeout(() => {
            this.recordAudio = this.showRecordAudioToggle && this.botAccount.extras['blipchat-record-audio'] === 'True';
            const recordAudioElements = document.getElementsByName('recordAudio');
            if (recordAudioElements && recordAudioElements.length > 0) {
                const recordAudioElement = recordAudioElements[0];
                recordAudioElement.checked = this.recordAudio;
            }
        });
    }
    initOpenImageInFrame() {
        this.$timeout(() => {
            this.openImageInFrame = this.showOpenImageInFrameToggle && this.botAccount.extras['blipchat-open-image-in-frame'] === 'True';
            const openImageInFrameElements = document.getElementsByName('openImageInFrame');
            if (openImageInFrameElements && openImageInFrameElements.length > 0) {
                const openImageInFrameElement = openImageInFrameElements[0];
                openImageInFrameElement.checked = this.openImageInFrame;
            }
        });
    }
}
BlipChat2Controller.$inject = ['application', 'ApplicationService2', 'LoadingService', 'PermissionsService', 'MessagingHubService', 'ChannelsSegmentService', 'ngToast', 'clipboard', 'BLIPCHATWIDGETURI', 'BLIPCHATEXAMPLEURI', 'MEDIA_BUCKET_URI', 'MEDIA_PROFILE_FOR_AVATARS', '$translate', '$scope', '$rootScope', 'TenantService', 'BLIPCHATURI', 'BLIPCHATURITENANT', 'SharedToastsService', '$window', '$timeout', 'ChannelsService'];
